<template>
  <div id="app"
    :class="{ 'appLogin': !currentUser && this.$router.currentRoute.path != '/autenticacao' && this.$router.currentRoute.path != '/credenciamento' && this.$router.currentRoute.path != '/reciboRetencao' && this.$router.currentRoute.path != '/consultaRps' && this.$router.currentRoute.path != '/denunciaFiscal' && this.$router.currentRoute.path != '/contribuintes' && this.$router.currentRoute.path != '/autenticacaoDigital' }">
    <LoadingSpinner />
    <AlertToast />
    <Dialog :header="avisoAtual.titulo" :visible.sync="displayAvisoEntradaSistema" :style="{ width: '42vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true" v-if="currentUser && avisoAtual && avisoAtual.titulo">
      <h1 class="titulo-header">
        {{ avisoAtual.titulo }}
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayAvisoEntradaSistema = false" />
      </h1><br />
      <div v-if="avisoAtual.tipo == 'T'" v-html="avisoAtual.mensagem" />

      <label v-if="avisoAtual.tipo == 'Q'"><b>Assunto:</b></label>
      <div v-if="avisoAtual.tipo == 'Q'" v-html="avisoAtual.avisoAssunto.assunto" />
      <hr v-if="avisoAtual.tipo == 'Q'" />
      <label v-if="avisoAtual.tipo == 'Q'"><b>Pergunta:</b></label>
      <div v-if="avisoAtual.tipo == 'Q'" v-html="avisoAtual.avisoItem.pergunta" />
      <hr v-if="avisoAtual.tipo == 'Q'" />
      <label v-if="avisoAtual.tipo == 'Q'"><b>Resposta:</b></label>
      <div v-if="avisoAtual.tipo == 'Q'" v-html="avisoAtual.avisoItem.resposta" />
      <hr/>
      <div class="container">
        <div class="row">
          <div>
            <Button label="Confirmar Leitura" icon="pi pi-check" @click="marcarAvisoLeitura()" class="mr-2"/>
            <Button label="Fechar" icon="pi pi-times" @click="hideAvisoPetrolina()" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Informação" :visible.sync="displayInformacao" :style="{ width: '42vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true" v-if="currentUser && msgInformacao">
      <h1 class="titulo-header">
        Informação
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayInformacao = false" />
      </h1><br />
      <div v-html="msgInformacao" />
      <hr/>
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="hideInformacao()" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <header v-if="currentUser">
      <div class="d-flex flex-column flex-md-row align-items-center p-3 px-md-3 mb-3 bg-white border-bottom box-shadow">
        <!--<img src="../assets/img/logo-jequie.png" alt width="50px" class="mr-5" /> -->
        <img v-if="!exibirLogoConfiguracao" :src="this.currentUser.configuracao.caminhoLogoHeaeder" alt width="50px"
          class="mr-5" />
        <img v-if="exibirLogoConfiguracao" :src="logoHeader" alt="Base64 encoded image" width="50px" class="mr-5" />
        <!-- <img src="../assets/img/logo-petrolina.png" alt width="50px" class="mr-5" />-->
        <h5 class="my-0 mr-md-auto header_empresa">
          <div>{{ this.currentUser.usuario.nomeCliente }}</div>
          <div class="header_contr" v-if="this.showUser && this.currentUser.contribuinte.idContribuinte">
            CPF/CNPJ: {{ this.currentUser.contribuinte.documento }}, {{ this.currentUser.contribuinte.nome }},
            Inscrição: {{ this.currentUser.contribuinte.inscMunic }}
          </div>
          <div class="header_usuario" v-if="showUser">Usuário: {{ this.currentUser.usuario.nome }}</div>
          <template
            v-if="this.currentUser && this.currentUser.contribuinte && this.currentUser.contribuinte.msgBloquearEmissaoMei">
            <Message severity="warn">{{ this.currentUser.contribuinte.msgBloquearEmissaoMei }}</Message>
          </template>
          <template
            v-else-if="this.currentUser && this.currentUser.contribuinte && this.currentUser.contribuinte.msgCredenciamentoDtel">
            <Message severity="warn">{{ this.currentUser.contribuinte.msgCredenciamentoDtel }}</Message>
          </template>
          <template v-else>
            <Message severity="warn" v-if="showUser && showInativo">Seu cadastro de contribuinte encontra-se Inativo ou
              Bloqueado, não
              será possível realizar ações de emissão!</Message>
          </template>
        </h5>

        <div class="dropleft" style="padding-left:14px">
          <i class="pi pi-list" style="font-size: 3.2rem;cursor:pointer" id="dropdownMenuButtonDetail"
            data-toggle="dropdown" aria-haspopup="true" title="Detalhes do Contribuinte" aria-expanded="false" />
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonDetail">
            <a class="dropdown-item" href="#">
              <span style="font-weight: bold">Regime de Tributação:</span>
              {{ this.currentUser.contribuinte.regimeTributacao }}
            </a>
            <a class="dropdown-item" href="#">
              <span style="font-weight: bold">Natureza de Operação:</span>
              {{ this.currentUser.contribuinte.naturezaOperacao }}
            </a>
            <a class="dropdown-item" href="#">
              <span style="font-weight: bold">Optante Simples Nacional:</span>
              {{ this.currentUser.contribuinte.optanteSs }}
            </a>
          </div>
        </div>
        <div class="dropleft" style="padding-left:14px">
          <i class="pi pi-user-edit" style="font-size: 3.3em;cursor:pointer" id="dropdownMenuButtonContr"
            title="Selecionar Contribuinte de Trabalho"
            v-if="!this.currentUser.usuarioUnico && this.$router.currentRoute.path != '/acessoEmpresa'"
            @click="selecaoContr()" />
        </div>
        <div class="dropleft" style="padding-left:14px">
          <i v-badge="this.currentUser && this.currentUser.contadorMsg ? this.currentUser.contadorMsg : 0"
            class="pi pi-envelope p-overlay-badge" style="font-size: 3.3em;cursor:pointer" id="dropdownMenuButtonContr"
            title="Caixa de Mensagens" @click="caixaMensagem()">
            <!-- <span ></span> -->
          </i>
        </div>
        <div class="dropleft" style="padding-left:var(--border-radius)">
          <i class="pi pi-user" style="font-size: 2.8em;cursor:pointer" id="dropdownMenuButtonINf"
            data-toggle="dropdown" aria-haspopup="true" title="Informações do Usuário" aria-expanded="false" />
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonINf">
            <a class="dropdown-item" :href="this.currentUser.configuracao.linkManualAdmin"
              v-if="currentUser.usuario.idBolAdmin" target="_blank" download="Manual_Administrador.zip">Manual</a>
            <a class="dropdown-item" :href="this.currentUser.configuracao.linkManualContribuinte" v-else target="_blank"
              download="Manual_Contribuinte.zip">Manual</a>
            <a class="dropdown-item" href="#" @click="downloadLayout()">Layout de integração Web Service</a>
            <a class="dropdown-item" target="parent"
              href="https://s3.amazonaws.com/el.com.br/nfse/importacao_aceites_v3.zip">Layout Importação de Aceites
              Substituição</a>
            <a class="dropdown-item" href="#" @click="atualizarSenha()">Atualizar Senha</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" @click="exit()">Sair</a>
          </div>
        </div>
      </div>

      <nav class="navbar navbar-expand-md navbar-dark bg-dark" v-if="this.currentUser.acessoMenu">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
          aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item dropdown" v-for="pagina in this.currentUser.paginas" :key="pagina.id">
              <template v-if="pagina.id !== '999'">
                <a class="nav-link dropdown-toggle" href="#" id="dropdown01" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">{{ pagina.nome }}</a>
                <div class="dropdown-menu" aria-labelledby="dropdown01">
                  <router-link v-for="item in pagina.items" :key="item.id" :to="item.navegacao" class="dropdown-item">{{
                    item.nome }}</router-link>
                </div>
              </template>
              <template v-else>
                <a class="nav-link" href="#" @click="abrirExtrato()" id="dropdown02" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">{{ pagina.nome }}</a>
              </template>
            </li>
            <li class="nav-item dropdown" v-if="this.baseUrlExtrato">
              <a class="nav-link" href="#" @click="abrirExtratoUrl()" id="dropdown03" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">Extrato de Débitos</a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <main role="main" class="main-content">
      <div class="container-fluid">
        <router-view />
      </div>
      <br />
    </main>

    <!-- RODAPÉ -->
    <footer class="footer" id="footer-links">
      <div class="footer-container">
        <div class="footer-section-nome">
          <!-- NOME SISTEMA -->
          <h4>GPI - Nota Fiscal de Serviço Eletrônica</h4>
        </div>
        <!-- COPY -->
        <div class="footer-section">
          <p>© {{ new Date().getFullYear() }} E&L Produções de Software Ltda.</p>
        </div>
        <!-- VERSAO -->
        <div class="footer-section-version">
          <!-- SE FOR DEIXAR PODEMOS COLCOAR A VERSAO DINAMICA SEMPRE QUE FOR ATUALIZADO -->
          <!--<h4>Versão: 1.1 - 05/11/2024 - 12:24:48</h4> -->
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
import LoginService from "./services/acesso/login.service";
import UsuarioContribuinteService from "./services/tributario/usuario.contribuinte.service";
import Aviso from "./models/nfse/Aviso";
import AvisoUsuarioLeitura from "./models/nfse/AvisoUsuarioLeitura";
import AvisoService from "./services/nfse/aviso.service";
import LoadingSpinner from "./components/global/LoadingSpinner";
import AlertToast from "./components/global/AlertToast";
import ReportService from "./services/report.service";

export default {
  components: {
    LoadingSpinner,
    AlertToast,
  },
  data() {
    return {
      currentUser: null,
      paginaId: null,
      itemId: null,
      showUser: true,
      showInativo: false,
      anoAtual: null,
      displayAvisoEntradaSistema: false,
      avisoAtual: new Aviso(),
      dataInicial: null,
      dataFinal: null,
      baseUrlExtrato: null,
      exibirLogoConfiguracao: false,
      logoHeader: null,
      displayInformacao: false,
      msgInformacao:null
    };
  },
  computed: {
    isLoginPage() {
      // Verifica se o nome da rota atual é 'Login'
      return this.$route.name === 'Login'; // Ajuste para o nome correto da sua rota
    },
  },
  methods: {
    abrirExtrato() {
      if (this.currentUser && this.currentUser.contribuinte && this.currentUser.contribuinte.documento) {
        this.processando(true);
        UsuarioContribuinteService.cript(this.currentUser.contribuinte.documento).then(
          (response) => {
            console.log(response);
            window.open("https://gpi-trb-portal.portovelho.ro.gov.br/extrato?opcao=" + response.data, '_blank', 'noreferrer');
          }
        ).then(() => {
          this.processando(false);
        });
      }
    },
    abrirExtratoUrl() {
      if (this.currentUser && this.currentUser.contribuinte && this.currentUser.contribuinte.documento) {
        this.processando(true);

        UsuarioContribuinteService.cript(this.currentUser.contribuinte.documento).then(
          (response) => {
            console.log(response);
            window.open(this.baseUrlExtrato + "/extrato?opcao=" + response.data, '_blank', 'noreferrer');
          }
        ).then(() => {
          this.processando(false);
        });
      }
    },
    exit() {
      LoginService.logOut();
      this.$router.push("/login");
    },
    atualizarSenha() {
      let link =
        "/recuperarSenha?chave=" +
        this.currentUser.usuario.idUsuario +
        ";" +
        this.currentUser.usuario.idPessoa;
      LoginService.logOut();
      this.$router.push(link);
    },
    downloadLayout() {
      ReportService.downloadResourceServer("layout_rps_2.04.zip");
      console.log("Download");
    },
    processando(show) {
      if (show) {
        this.$root.$emit("loading:show");
      } else {
        this.$root.$emit("loading:hide");
      }
    },
    selecaoContr() {
      this.$router.push("/selecaoEmpresa");
    },
    caixaMensagem() {
      this.$router.push("/caixaMensagem");
    },
    hideAvisoPetrolina() {
      localStorage.setItem('displayAvisoEntradaSistema', 'N');
      this.displayAvisoEntradaSistema = false;
    },
    hideInformacao() {
      localStorage.setItem('displayInformacao', 'N');
      this.displayInformacao = false;
    },
    carregarAviso() {
      this.processando(true);
      AvisoService.findAllNaoLidas(this.currentUser.usuario.idCliente, this.currentUser.usuario.idUsuario, this.currentUser.contribuinte.idContribuinte).then(
        (response) => {
          console.log(response);
          this.avisoAtual = response.data[0];
          this.displayAvisoEntradaSistema = true;
        }
      ).then(() => {
        this.processando(false);
      });

    },
    marcarAvisoLeitura() {
      let a = new AvisoUsuarioLeitura();
      a.idUsuario = this.currentUser.usuario.idUsuario;
      a.idAviso = this.avisoAtual.id;
      this.processando(true);
      this.hideAvisoPetrolina();
      AvisoService.save(a).then(
        (response) => {
          console.log(response);
          this.$toast.add({
            severity: "success",
            summary: "Aviso marcado como Lido!",
            life: 3000
          });
        }
      ).then(() => {
        this.processando(false);
      });
    },
    carregarLogo() {
      this.exibirLogoConfiguracao = false;
      if (this.currentUser && this.currentUser.configuracao && this.currentUser.configuracao.logoHeader && this.currentUser.configuracao.logoHeader != null) {
        this.exibirLogoConfiguracao = true;
        this.logoHeader = "data:image/jpg;base64,".concat(this.currentUser.configuracao.logoHeader);
      }
    }
  },
  watch: {
    $route(to, from) {
      this.showInativo = false;
      this.processando(false);
      //You can get warning (error: 'from' is defined but never used), if you don't use parameters;
      console.log(to.path + " -> " + from.path);
      this.showUser = true;
      if (to.path == "/acessoEmpresa" || to.path == "/selecaoEmpresa") {
        this.showUser = false;
      }
      this.currentUser = LoginService.currentUserValue;
      this.showInativo =
        this.currentUser && this.currentUser.contribuinte
          ? !this.currentUser.contribuinte.ativo
          : false;

      this.carregarLogo();
      let dispInf = localStorage.getItem('displayInformacao');
      let dispAviso = localStorage.getItem('displayAvisoEntradaSistema');
      this.displayInformacao = false;
      if(dispInf != 'N' && this.currentUser.contribuinte.idContribuinte != null && this.currentUser.contribuinte.msgAvisoDebitoRdt != null) {
        this.displayInformacao = true;
        this.msgInformacao = this.currentUser.contribuinte.msgAvisoDebitoRdt;
        localStorage.setItem('displayInformacao', 'S');
      } else if (dispAviso != 'N' && this.currentUser && this.currentUser.usuario.countAvisos && this.currentUser.usuario.countAvisos > 0 && this.currentUser.contribuinte.idContribuinte != null) {

        localStorage.setItem('displayAvisoEntradaSistema', 'S');
        this.carregarAviso();
      }
    }
  },
  mounted() {
    var d = new Date();
    this.anoAtual = d.getFullYear();
  },
  created() {
    this.baseUrlExtrato = (this.$baseUrlExtrato ? this.$baseUrlExtrato : null);
    this.showInativo = false;
    this.currentUser = LoginService.currentUserValue;
    this.showInativo =
      this.currentUser && this.currentUser.contribuinte
        ? !this.currentUser.contribuinte.ativo
        : false;

    this.dataInicial = new Date();
    this.dataFinal = new Date();
    this.dataInicial.setDate(this.dataInicial.getDate() - 30);

    this.carregarLogo();

  }
};
</script>

<style src="../src/assets/css/app.css"></style>
